import React from 'react'
import InfoCircleRedSvg from '../../../assets/icons/InfoCircleRedSvg'

const InfoRedCard = ({ text }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '1rem 0 1.5rem 0',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          // margin: '2rem 1.5rem 0 1.5rem',
          borderRadius: '10px',
          backgroundColor: '#E9C8C8',
          padding: '0.8rem 0.4rem',
          width: '100%',
          // minHeight: '100px'
        }}
      >
        <div style={{ padding: '0 1rem 0 0.5rem' }}>
          <InfoCircleRedSvg width={'1.2rem'} height={'1.2rem'} />
        </div>
        <div style={{ fontSize: '13px', fontWeight: '300' }}>{text}</div>
      </div>
    </div>
  )
}

export default InfoRedCard
